export default class SearchListing {
  constructor(element) {
    const link = element.querySelector('.search-listing__link');
    link?.focus();
  }
}
